var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.634,
    height: 13.149,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": 123,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37573",
    style: {
      isolation: "isolate"
    },
    fill: "#3b5175"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21782",
    d: "M5.572 12.973h-2.54V3.182L0 4.122V2.057l5.3-1.9h.273Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21783",
    d: "M18.505 12.973H9.733v-1.74l4.14-4.412a10.277 10.277 0 0 0 1.26-1.626 2.612 2.612 0 0 0 .41-1.319 1.961 1.961 0 0 0-.431-1.341 1.558 1.558 0 0 0-1.231-.487 1.679 1.679 0 0 0-1.358.593 2.352 2.352 0 0 0-.5 1.56H9.474a4.193 4.193 0 0 1 .558-2.135A3.936 3.936 0 0 1 11.61.549 4.809 4.809 0 0 1 13.921 0a4.545 4.545 0 0 1 3.072.949 3.361 3.361 0 0 1 1.094 2.681 4.308 4.308 0 0 1-.492 1.934 10.738 10.738 0 0 1-1.687 2.294l-2.909 3.067h5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21784",
    d: "M22.64 5.449h1.354a1.907 1.907 0 0 0 1.432-.483 1.769 1.769 0 0 0 .466-1.283 1.564 1.564 0 0 0-.462-1.2 1.785 1.785 0 0 0-1.269-.431 1.877 1.877 0 0 0-1.222.4 1.28 1.28 0 0 0-.492 1.042h-2.54a3.122 3.122 0 0 1 .54-1.8A3.592 3.592 0 0 1 21.959.451a5.042 5.042 0 0 1 2.14-.449 4.788 4.788 0 0 1 3.182.971 3.317 3.317 0 0 1 1.151 2.677 2.7 2.7 0 0 1-.536 1.617 3.485 3.485 0 0 1-1.406 1.134 3.177 3.177 0 0 1 1.612 1.16 3.141 3.141 0 0 1 .532 1.828 3.367 3.367 0 0 1-1.244 2.733 5 5 0 0 1-3.291 1.029 4.744 4.744 0 0 1-3.134-1.011 3.3 3.3 0 0 1-1.216-2.672h2.54a1.47 1.47 0 0 0 .54 1.178 2.253 2.253 0 0 0 2.751-.023 1.652 1.652 0 0 0 .514-1.269q0-1.917-2.109-1.916H22.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberChart);
export default __webpack_public_path__ + "static/media/number-chart.8e8ec567e6c8388b6ef27cf8d5e12152.svg";
export { ForwardRef as ReactComponent };